<template>
 
       <v-card flat>
        <v-card-title>GET - /api/postcodes/{postcode}/autocomplete</v-card-title>
        <hr />

        <v-card-text>
          <v-simple-table class="table">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>HTTP Method :</td>
                  <td>GET</td>
                </tr>
                <tr>
                  <td>URL :</td>
                  <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
                  
                </tr>
                <tr>
                  <td>Description :</td>
                  <td>
                    This function allows you to get an address based on the postcode and number of results.
                    This function gives address based on postcode in code value .
                    <br />It gives the response based on the request parameters.
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-title>Request Parameters:</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Parameter Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Parameter Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>postcode</td>
                  <td>Postcode value to get address</td>
                  <td>path</td>
                </tr>
                <tr>
                  <td>numberOfResults</td>
                  <td>Limit of result records</td>
                  <td>query</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-title>Postcode:</v-card-title>
        <v-card-text>
          <ul>
            <li>Postcode value should contain Outcode.</li>
            <li>If you are using full postcode to get a response, then Outcode and Incode must be separated by single space. E.g. RG1 7BL</li>
          </ul>
        </v-card-text>

        <v-card-title>numberOfResults:</v-card-title>
        <v-card-text>
          <ul>
            <li>Default number of results size is 10</li>
            <li>We can enter a numberOfResults maximum value is Int.</li>
            <li>This numberOfResults parameter limits the response results</li>
          </ul>
        </v-card-text>

        <v-card-text>
          <pre>
          <code>E.g. Postcode Outcode is - RG1 and numberOfResults=10 then below is the JSON response.</code>
          </pre>
        </v-card-text>

        <v-card-title>JSON Response:</v-card-title>
        <v-card-text>
          <pre>
          <code v-html="jsonText" />
          </pre>
        </v-card-text>
        <br/>
      </v-card>
</template>

<script>
export default {
  name: "autocomplete",
  
  data: () => ({
     url: process.env.VUE_APP_BASE_URL,
    restUrl: "postcodes/{postcode}/autocomplete",
    jsonText: [
      "ABATTOIRS ROAD, READING, BERKSHIRE,RG1 7BL",
      "ABBEY SQUARE, READING, BERKSHIRE,RG1 3BE",
      "ABBEY SQUARE, READING, BERKSHIRE,RG1 3BQ",
      "ABBEY SQUARE, READING, BERKSHIRE,RG1 3FB",
      "ABBEY SQUARE, READING, RG1 3AG",
      "ABBEY STREET, READING, BERKSHIRE,RG1 3BA",
      "ABBEY STREET, READING, BERKSHIRE,RG1 3BD",
      "ABBOTS WALK, READING, BERKSHIRE,RG1 3HW",
      "ADDINGTON ROAD, READING, BERKSHIRE,RG1 5LT",
      "ADDINGTON ROAD, READING, BERKSHIRE,RG1 5PH"
    ],
  })
};
</script>

